/**
 * Inbox Page - WhatsApp conversation inbox with customer profile split-view
 */

import { InboxLayout } from '../components/inbox/InboxLayout';

export function InboxPage() {
  return (
    <div className="h-[calc(100vh-4rem)]">
      <InboxLayout />
    </div>
  );
}
